import { ButtonLinkExternal } from '@app/components/base/ButtonLinkExternal';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { getOauthConnectUrl } from './get-oauth-connect-url';

interface Props {
  platform: SocialPlatform;
  children?: ReactNode;
  loginSuffix?: string;
}

/**
 * OAuth connect button for a platform. Connections are client-owned (no station in the login URL).
 */
export function DefaultPlatformConnect({ platform, children, loginSuffix }: Props) {
  const { $t } = useIntl();
  const connectUrl = getOauthConnectUrl(platform, loginSuffix);

  return (
    <ButtonLinkExternal
      to={connectUrl}
      variant="outlined"
      color="primary"
      size="small"
      startIcon={platform.Icon()}
    >
      {children ?? <>{$t({ id: 'socialExport.connect', defaultMessage: 'Conectar' })}</>}
    </ButtonLinkExternal>
  );
}
